module.exports = __webpack_public_path__ + "img/aqsc1.65170736.png";